import authService from "../../../services/authService";
import http from "../../../services/httpService";

// const apiEndpoint = "/hedge-brown-server/api/dept-or-prgms";
const apiEndpoint = "/api/committee-members";


function create(data) {
   return http.post(apiEndpoint, data);
}

function update(data) {
  
  return http.put(`${apiEndpoint}/${data.id}`, data);
}
function partialUpdate(data) {
  
  return http.patch(`${apiEndpoint}/${data.id}`, data);
}

function get(id) {
  return http.get(`${apiEndpoint}/${id}`);
}

function getAll() {
  return http.get(apiEndpoint);
}

function getAllByCommittee(committeeId) {
  return http.get(`${apiEndpoint}/committee/${committeeId}`);
}


function deleteById(id) {
  return http.delete(`${apiEndpoint}/${id}`);
}

export default {
  create,
  update,
  partialUpdate,
  get,
  getAll,
  getAllByCommittee,
  deleteById
};
